import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/home/zebrafashion/zebrafashion.com/releases/75947690/layouts/account.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/home/zebrafashion/zebrafashion.com/releases/75947690/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/zebrafashion/zebrafashion.com/releases/75947690/layouts/default.vue").then(m => m.default || m))
}